export type Theme = "dark" | "ivory";

const KEY = "alpha.theme";

export function storedTheme(): Theme {
  try {
    return localStorage.getItem(KEY) === "ivory" ? "ivory" : "dark";
  } catch {
    return "dark";
  }
}

/** Sets html.ivory for the light look (dark is the default, no class) and remembers the choice. */
export function applyTheme(theme: Theme, remember = true): void {
  document.documentElement.classList.toggle("ivory", theme === "ivory");
  if (remember) {
    try {
      localStorage.setItem(KEY, theme);
    } catch {
      /* storage unavailable: the choice just is not remembered */
    }
  }
  window.dispatchEvent(new CustomEvent("alpha-theme", { detail: theme }));
}

export const currentTheme = (): Theme => (document.documentElement.classList.contains("ivory") ? "ivory" : "dark");
